import { render, staticRenderFns } from "./pda-summary.vue?vue&type=template&id=648f1830"
import script from "./pda-summary.vue?vue&type=script&lang=ts"
export * from "./pda-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports